import { Box, useTheme } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';

interface AiInsightsLogoProps {
    size?: '24px' | '32px';
    variant?: 'primary' | 'white' | 'dark';
}

const AiInsightsLogo = ({ size = '24px', variant = 'white' }: AiInsightsLogoProps) => {
    const theme = useTheme();
    const logoColor = (() => {
        switch (variant) {
            case 'white':
                return theme.palette.white[100];
            case 'dark':
                return theme.palette.primary.dark;
            default:
                return theme.palette.primary.main;
        }
    })();

    return (
        <Box
            sx={{
                width: size,
                height: size,
                color: logoColor,
                position: 'relative',
                display: 'inline-flex',
            }}
            title="AI Insights"
        >
            <AutoAwesome
                sx={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    transform: 'translateY(-5%) translateX(-22%) scale(0.65) scaleX(-1)',
                }}
            />
            <svg
                width="20"
                height="20"
                viewBox="0 0 12 12"
                style={{
                    position: 'absolute',
                    right: 0,
                    bottom: '6%',
                    color: 'inherit',
                }}
            >
                <path
                    d="M6 12V9.544c1.956 0 3.546-1.59 3.546-3.544S7.956 2.456 6 2.456V0c3.308 0 6 2.692 6 6s-2.692 6-6 6z"
                    fill="currentColor"
                />
            </svg>
        </Box>
    );
};

export default AiInsightsLogo;
